import { AfterViewInit, Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import {
  SocialLoginModule,
  GoogleSigninButtonModule,
  SocialAuthService,
  GoogleLoginProvider,
} from '@abacritt/angularx-social-login';
import { NotificationComponent } from '@standard-angular-utilities/shared-components';
import { UserService } from 'BaseServices/user-service';

import { NotificationService } from 'BaseServices/notification.service';

@Component({
  selector: 'main-app-root',
  imports: [
    RouterOutlet,
    HeaderComponent,
    SocialLoginModule,
    GoogleSigninButtonModule,
    NotificationComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'ProjectWorkspace';
  showHeader = true;
  constructor(
    private authService: SocialAuthService,
    public userService: UserService,
    public router: Router,
    public notificationService: NotificationService
  ) {
    this.authService.authState.subscribe((user) => {
      if (user) {
        this.userService.validateGoogleLogin(user);
      }
    });
    const currentUrl = window.location.href; // Get the full URL
    this.userService.manualLogin$.subscribe((result) => {
      if (result) {
        const relativePath = currentUrl.split(window.location.origin)[1];
        this.router.navigate([relativePath]);
      }
    });

    if (currentUrl.includes("udstyr/KontrollerUdstyr")) {
      this.showHeader = false;
    }

  }

  get currentUser() {
    return this.userService.currentUser;
  }

  get isWatermanager() {
    return this.router.url.toLowerCase().includes('watermanager');
  }
}
